import {
  decideTaskEmailReviewViaApiV2,
  LegacySignatureFormData,
} from "api/tasks/apiv2-task-actions";

/**
 * Email-reviewer decide — single approval-type tasks
 * (`TaskApprovalType.EMAIL`).
 */
export type SingleSubmitArgs = {
  showId: string;
  key: string;
  /**
   * Decision target (UUIDs from the verify response) — pins the verdict
   * to the instance the reviewer is looking at; the shared per-email
   * key alone is ambiguous when the reviewer has several tasks.
   */
  taskId?: string;
  standId?: string;
  approval: boolean;
  message?: string;
  isRevision?: boolean;
  files?: Array<{ file?: File | { name?: string; size?: number } }>;
  /**
   * Optional signature attached to the approve verdict. BE persists
   * it on `task_signatures` keyed by the email reviewer; silently
   * ignored on reject/revise (no verdict signature).
   */
  signature?: LegacySignatureFormData | null;
  /**
   * "Allow exhibitor to resubmit after approval" checkbox — BE persists it onto
   * `task_instances.allow_resubmit_after_approval` on the approve that flips the
   * instance to DONE, which is what the exhibitor's re-submit gate reads.
   */
  allowResubmitAfterApproval?: boolean;
};

async function singleSubmit({
  showId,
  key,
  taskId,
  standId,
  approval,
  message,
  isRevision,
  files,
  signature,
  allowResubmitAfterApproval,
}: SingleSubmitArgs) {
  await decideTaskEmailReviewViaApiV2({
    showId,
    key,
    taskId,
    standId,
    isApproved: approval,
    message,
    isRevision,
    files,
    signature,
    allowResubmitAfterApproval,
  });
  // Return empty array; the verdict triggers a notification and the
  // drawer re-fetches reaction files.
  return [];
}

export default singleSubmit;
